// extracted by mini-css-extract-plugin
export var shake = "_x-0";